import React from "react";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
const PaymentBreakdown = ({ allQData }) => {
  return (
    <div style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
      <p
        className="fw-bold mt-4 mb-0 text-uppercase"
        style={{
          fontSize: "1rem",
        }}
      >
        Payment Schedule :
        {/* {allQData?.input_info?.fullyAutomatedSystem
          ? " Fully Automated System"
          : " Semi Automated System"} */}
      </p>

      <div style={{ width: "100%" }} className="row m-0 p-0">
        {!allQData?.input_info?.selectedSystem && (
          <div className={"col-12 m-0 p-0"}>
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Payment Schedule </th>
                  <th className="col-2">As per Industry</th>
                  <th className="col-2">Kryzen Pro.</th>
                  <th className="col-2">Kryzen Pro Max</th>
                </tr>
              </thead>
              <tbody>
                {/* <tr>
                    <td>Site inspection & project report</td>

                    <td>{roundOffCost(50000)}</td>
                  </tr> */}
                {/* <tr>
                    <td>Work order & advance (10%)</td>

                    <td>{roundOffCost((cost + gstcost) * 0.1 - 50000)}</td>
                  </tr> */}
                <tr>
                  <td>Work order & advance (10%)</td>
                  <td>
                    {roundOffCost(
                      (allQData?.quotationMatrixCost?.asPerIndustryCost +
                        allQData?.quotationMatrixCost?.asPerIndustryCost *
                          0.18) *
                        0.1
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      (allQData?.quotationMatrixCost?.kryzenProCost +
                        allQData?.quotationMatrixCost?.kryzenProCost * 0.18) *
                        0.1
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      (allQData?.quotationMatrixCost?.kryzenProMaxCost +
                        allQData?.quotationMatrixCost?.kryzenProMaxCost *
                          0.18) *
                        0.1
                    )}
                  </td>
                </tr>
                {allQData?.input_info?.quotationType !== "fanpad" &&
                  allQData?.input_info?.quotationType !== "nvph" &&
                  allQData?.input_info?.quotationType !== "nethouse" &&
                  allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                  allQData?.input_info?.quotationType !== "soilbasednvph" &&
                  allQData?.input_info?.quotationType !==
                    "soilbasednethouse" && (
                    <>
                      <tr>
                        <td>
                          Before 1<sup>st</sup> vehicle dispatch (50%)
                        </td>
                        <td>
                          {roundOffCost(
                            (allQData?.quotationMatrixCost?.asPerIndustryCost +
                              allQData?.quotationMatrixCost?.asPerIndustryCost *
                                0.18) *
                              0.5
                          )}
                        </td>
                        <td>
                          {roundOffCost(
                            (allQData?.quotationMatrixCost?.kryzenProCost +
                              allQData?.quotationMatrixCost?.kryzenProCost *
                                0.18) *
                              0.5
                          )}
                        </td>
                        <td>
                          {roundOffCost(
                            (allQData?.quotationMatrixCost?.kryzenProMaxCost +
                              allQData?.quotationMatrixCost?.kryzenProMaxCost *
                                0.18) *
                              0.5
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Before 2<sup>nd</sup> vehicle dispatch (40%)
                        </td>

                        <td>
                          {roundOffCost(
                            (allQData?.quotationMatrixCost?.asPerIndustryCost +
                              allQData?.quotationMatrixCost?.asPerIndustryCost *
                                0.18) *
                              0.4
                          )}
                        </td>
                        <td>
                          {roundOffCost(
                            (allQData?.quotationMatrixCost?.kryzenProCost +
                              allQData?.quotationMatrixCost?.kryzenProCost *
                                0.18) *
                              0.4
                          )}
                        </td>
                        <td>
                          {roundOffCost(
                            (allQData?.quotationMatrixCost?.kryzenProMaxCost +
                              allQData?.quotationMatrixCost?.kryzenProMaxCost *
                                0.18) *
                              0.4
                          )}
                        </td>
                      </tr>
                    </>
                  )}
                {(allQData?.input_info?.quotationType === "fanpad" ||
                  allQData?.input_info?.quotationType === "nvph" ||
                  allQData?.input_info?.quotationType === "nethouse" ||
                  allQData?.input_info?.quotationType === "soilbasedfanpad" ||
                  allQData?.input_info?.quotationType === "soilbasednvph" ||
                  allQData?.input_info?.quotationType ===
                    "soilbasednethouse") && (
                  <>
                    <tr>
                      <td>
                        Before 1<sup>st</sup> vehicle dispatch (90%)
                      </td>
                      <td>
                        {roundOffCost(
                          (allQData?.quotationMatrixCost?.asPerIndustryCost +
                            allQData?.quotationMatrixCost?.asPerIndustryCost *
                              0.18) *
                            0.9
                        )}
                      </td>
                      <td>
                        {roundOffCost(
                          (allQData?.quotationMatrixCost?.kryzenProCost +
                            allQData?.quotationMatrixCost?.kryzenProCost *
                              0.18) *
                            0.9
                        )}
                      </td>
                      <td>
                        {roundOffCost(
                          (allQData?.quotationMatrixCost?.kryzenProMaxCost +
                            allQData?.quotationMatrixCost?.kryzenProMaxCost *
                              0.18) *
                            0.9
                        )}
                      </td>
                    </tr>
                  </>
                )}

                <tr
                  className={
                    !allQData?.input_info?.fullyAutomatedSystem ? "fw-bold" : ""
                  }
                >
                  <td>Total (100%)</td>
                  <td>
                    {roundOffCost(
                      allQData?.quotationMatrixCost?.asPerIndustryCost +
                        allQData?.quotationMatrixCost?.asPerIndustryCost * 0.18
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.quotationMatrixCost?.kryzenProCost +
                        allQData?.quotationMatrixCost?.kryzenProCost * 0.18
                    )}
                  </td>
                  <td>
                    {roundOffCost(
                      allQData?.quotationMatrixCost?.kryzenProMaxCost +
                        allQData?.quotationMatrixCost?.kryzenProMaxCost * 0.18
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        {allQData?.input_info?.selectedSystem === "As Per Industry" && (
          <div className={"col-12 m-0 p-0"}>
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th className="col-8">Payment Schedule </th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Work order & advance (10%)</td>
                  <td>
                    {roundOffCost(
                      (allQData?.quotationMatrixCost?.asPerIndustryCost +
                        allQData?.quotationMatrixCost?.asPerIndustryCost *
                          0.18) *
                        0.1
                    )}
                  </td>
                </tr>
                {allQData?.input_info?.quotationType !== "fanpad" &&
                  allQData?.input_info?.quotationType !== "nvph" &&
                  allQData?.input_info?.quotationType !== "nethouse" &&
                  allQData?.input_info?.quotationType !== "soilbasedfanpad" &&
                  allQData?.input_info?.quotationType !== "soilbasednvph" &&
                  allQData?.input_info?.quotationType !==
                    "soilbasednethouse" && (
                    <>
                      <tr>
                        <td>
                          Before 1<sup>st</sup> vehicle dispatch (50%)
                        </td>
                        <td>
                          {roundOffCost(
                            (allQData?.quotationMatrixCost?.asPerIndustryCost +
                              allQData?.quotationMatrixCost?.asPerIndustryCost *
                                0.18) *
                              0.5
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Before 2<sup>nd</sup> vehicle dispatch (40%)
                        </td>

                        <td>
                          {roundOffCost(
                            (allQData?.quotationMatrixCost?.asPerIndustryCost +
                              allQData?.quotationMatrixCost?.asPerIndustryCost *
                                0.18) *
                              0.4
                          )}
                        </td>
                      </tr>
                    </>
                  )}
                {(allQData?.input_info?.quotationType === "fanpad" ||
                  allQData?.input_info?.quotationType === "nvph" ||
                  allQData?.input_info?.quotationType === "nethouse" ||
                  allQData?.input_info?.quotationType === "soilbasedfanpad" ||
                  allQData?.input_info?.quotationType === "soilbasednvph" ||
                  allQData?.input_info?.quotationType ===
                    "soilbasednethouse") && (
                  <>
                    <tr>
                      <td>
                        Before 1<sup>st</sup> vehicle dispatch (90%)
                      </td>
                      <td>
                        {roundOffCost(
                          (allQData?.quotationMatrixCost?.asPerIndustryCost +
                            allQData?.quotationMatrixCost?.asPerIndustryCost *
                              0.18) *
                            0.9
                        )}
                      </td>
                    </tr>
                  </>
                )}

                <tr
                  className={
                    !allQData?.input_info?.fullyAutomatedSystem ? "fw-bold" : ""
                  }
                >
                  <td>Total (100%)</td>
                  <td>
                    {roundOffCost(
                      allQData?.quotationMatrixCost?.asPerIndustryCost +
                        allQData?.quotationMatrixCost?.asPerIndustryCost * 0.18
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td className="col-8">
              <b className="ms-2">Payment Details :</b>
              <div className="row my-0">
                <div className="col-3 ms-2">Name</div>
                <div className="col">
                  : <b>KRYZEN BIOTECH PRIVATE LIMITED</b>
                </div>
              </div>
              <div className="row my-0">
                <div className="col-3 ms-2">Bank</div>
                <div className="col">
                  : <b>ICICI BANK</b>
                </div>
              </div>{" "}
              <div className="row my-0">
                <div className="col-3 ms-2">Account No.</div>
                <div className="col">
                  : <b>016905015915</b>
                </div>
              </div>{" "}
              <div className="row my-0">
                <div className="col-3 ms-2">IFSC</div>
                <div className="col">
                  : <b>ICIC0007565</b>
                </div>
              </div>
            </td>
            <td className="text-center m-0 p-0">
              <img
                width={"70%"}
                className="m-0 p-0"
                src={
                  "https://res.cloudinary.com/dsmabnook/image/upload/v1749635412/signature_cztq8j_p5hwwc.png"
                }
                alt="kryzen signature"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
    </div>
  );
};

export default PaymentBreakdown;
